var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf_nc_special_detail_course_item" }, [
    _vm.lists.length
      ? _c(
          "ul",
          { staticClass: "nc_detail_wrap" },
          _vm._l(_vm.lists, function (item, index) {
            return _c("li", { key: index, staticClass: "nc_detail_item" }, [
              _c("div", { staticClass: "detail_top" }, [
                _c("div", { staticClass: "item_title" }, [
                  _vm._v(_vm._s(item.unitName)),
                ]),
                _c("div", { staticClass: "item_top_right" }, [
                  _c("span", [
                    _vm._v("选修：" + _vm._s(item.electives || 0) + " 门"),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(item.electivesPeriod || 0) + " 学时"),
                  ]),
                  _c("span", [
                    _vm._v("必修：" + _vm._s(item.compulsory || 0) + " 门"),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(item.compulsoryPeriod || 0) + " 学时"),
                  ]),
                  item.fold
                    ? _c("span", {
                        staticClass: "icon iconfont icon-xia1 sq",
                        on: {
                          click: function ($event) {
                            return _vm.clickFold(index)
                          },
                        },
                      })
                    : _vm._e(),
                  !item.fold
                    ? _c("span", {
                        staticClass: "icon iconfont icon-shang1 sq",
                        on: {
                          click: function ($event) {
                            return _vm.clickFold(index)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              item.fold
                ? _c(
                    "div",
                    { staticClass: "detail_desc" },
                    _vm._l(item.subList, function (items, idx) {
                      return _c(
                        "div",
                        { key: items.subId, staticClass: "detail_desc_item" },
                        [
                          _c("div", { staticClass: "detail_desc_left" }, [
                            _c("i", {
                              class:
                                "icon iconfont " + _vm.setIcon(items.typeValue),
                            }),
                            _c("span", { staticClass: "type_name" }, [
                              _vm._v(_vm._s(items.typeText)),
                            ]),
                            _c(
                              "span",
                              {
                                class:
                                  "type_category " +
                                  (items.categoryText == "必修" ? "bx" : "xx"),
                              },
                              [_vm._v(_vm._s(items.categoryText))]
                            ),
                            _c("span", { staticClass: "detail_name" }, [
                              _vm._v(_vm._s(items.name)),
                            ]),
                          ]),
                          _c("div", { staticClass: "detail_desc_right" }, [
                            _c("div", { staticClass: "detail_time font" }, [
                              _vm._v(_vm._s(items.duration)),
                            ]),
                            _c("div", { staticClass: "wcxs font" }, [
                              _vm._v(_vm._s(items.teacher || "")),
                            ]),
                            _c(
                              "div",
                              { staticClass: "progress" },
                              [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: items.progress || 0,
                                    "stroke-width": "11",
                                    "show-text": false,
                                  },
                                }),
                                _c("span", { staticClass: "pivot-txt" }, [
                                  _vm._v(_vm._s(items.progress || 0) + "%"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "enter_btn",
                                style:
                                  "" +
                                  (_vm.itemStatus(
                                    items,
                                    item,
                                    idx,
                                    idx > 0
                                      ? item.subList[idx - 1].progress
                                      : null
                                  ) && items.playState
                                    ? ""
                                    : "background: #aaa; cursor: default"),
                                on: {
                                  click: function ($event) {
                                    _vm.showClick &&
                                      items.playState &&
                                      _vm.clickEnter(
                                        items,
                                        item.classId,
                                        item,
                                        idx,
                                        idx > 0
                                          ? item.subList[idx - 1].progress
                                          : null
                                      )
                                  },
                                },
                              },
                              [_vm._v(" 进入 ")]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          }),
          0
        )
      : _c("div", { staticClass: "no_data" }, [_vm._v(" 暂无数据 ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }